// @flow
import React, {useContext, useEffect, useRef, useState} from "react";
import Header from "./Header";
import BackButton from "../GUI_COMMON/COMPONENTS/BackButton";
import LIButton from "../GUI_COMMON/COMPONENTS/LIButton";
import Popup from "../GUI_COMMON/COMPONENTS/Popup";
import ArchiverClientApi,{DOWNLOADABLE_FILE_PARENT_LIST} from "../API/archiverClientApi";
import ErrorPopup from "../GUI_COMMON/COMPONENTS/ErrorPopup";
import {useLocation} from "react-router-dom";
import LIUtils from "../GUI_COMMON/SUPPORT/LIUtils";
import {useCookies} from "react-cookie";
import HeaderBadge from "../GUI_COMMON/COMPONENTS/HeaderBadge";
import {StoreContext} from "../GUI_COMMON/SUPPORT/store";
import ArchiverGuiUtils from "../SUPPORT/ArchiverGuiUtils";
import {useHistory} from "react-router";
import ReloadButton from "../GUI_COMMON/COMPONENTS/ReloadButton";

const AdminPage = () => {

    const DEFAULT_PICK_DIR_VERBIAGE = "pick a directory";
    const DEFAULT_PICK_FILE_VERBIAGE = "pick a file";
    const DEFAULT_TRIAGE_COUNTS = {
        newCount:0,
        processingCount:0
    };
    
    //const [redirectToPush, setRedirectToPush] = useState();
    const [globalState,] = useContext(StoreContext);

    const [downloadableFilesList, setDownloadableFilesList] = useState([]);
    const [selectedFileParentDir, setSelectedFileParentDir] = useState();
    const [selectedDownloadFile, setSelectedDownloadFile] = useState();
    const [isBusyDownloadingFile, setIsBusyDownloadingFile] = useState(false);
    const [isBusyResettingDb, setIsBusyResettingDb] = useState(false);
    const [addSamples, setAddSamples] = useState(false);
    const [reportUploadIsBusy, setReportUploadIsBusy] = useState(false);
    const [dashboardCounts, setDashboardCounts] = useState({
        eventsCount: 0,
        notifsCount: 0,
        printJobsCount: 0,
        externalProcJobsCount: 0,
        triageSamplesCount: DEFAULT_TRIAGE_COUNTS,   
    });
    const [isClearingEvents, setIsClearingEvents] = useState(false);
    const [isClearingNotifs, setIsClearingNotifs] = useState(false);
    const [isClearingPrintJobs, setIsClearingPrintJobs] = useState(false);
    
    const location = useLocation();
    const history = useHistory();
    
    const [cookies,] = useCookies();
    const generalRef = useRef();
    const serviceRef = useRef();
    const magRef = useRef();
    const boxRef = useRef();
    const userRef = useRef();
    const locationRef = useRef();
    const reportRef = useRef();
    const deviceRef = useRef();

    const [activePageRef, setActivePageRef] = useState();
    
    useEffect( () => {
        hideAllTabPages();
        const pageAnchor = location.hash.replace("#","");
        if(pageAnchor==="magazines") {
            showTabPage(magRef);
        } else if(pageAnchor==="boxes") {
            showTabPage(boxRef);
        }else if(pageAnchor==="users") {
            showTabPage(userRef);
        } else if(pageAnchor==="locations") {
            showTabPage(locationRef);
        } else if(pageAnchor==="reports") {
            showTabPage(reportRef);
        } else if(pageAnchor==="devices") {
            showTabPage(deviceRef);
        } else if(pageAnchor==="service") {
            showTabPage(serviceRef);
        }
        else {
            showTabPage(generalRef);
        }
        
    },[]);  // eslint-disable-line react-hooks/exhaustive-deps
    
    useEffect( () => {
        if(activePageRef===generalRef) {
            doUpdateInterestingCounts();
        }
        
    }, [activePageRef]);  // eslint-disable-line react-hooks/exhaustive-deps
    
    function doUpdateInterestingCounts() {
        ArchiverClientApi.getAdminDashboardCounts()
        .then( (results) => {
            setDashboardCounts({
                eventsCount: results.numEvents, 
                notifsCount: results.numNotifs, 
                printJobsCount: results.numPrintJobs,
                externalProcJobsCount: results.numExternalProcessJobs,
                triageSamplesCount: results.numTriageSamples??DEFAULT_TRIAGE_COUNTS
            });
        })
    }
    
    function handleClearMagClicked() {
        Popup.showPrompt("Clear Magazine","","Remove Samples",() => {},(magBC) => {
            if(magBC && magBC!=="") {
                confirmAndRemoveClearMag(magBC);
            }
        },1, "magazine barcode (##.####.#)");
    }
    function confirmAndRemoveClearMag(magBC) {
        Popup.showConfirm("Remove Samples?",
            `<p>Are you sure you want to remove all samples from mag '${magBC}'?</p>` +
            "<p>*this may take some time if the mag is full.</p>", "Yes, Remove!",
            null, () => {
                ArchiverClientApi.requestReloadOfMag(magBC)
                .then(() => {
                    Popup.show("Mag Reloaded", `All child samples have been removed <MagBadge text='${magBC}'/>`);
                })
                .catch(responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError));
            });
    }
    function handleDiscardMagClicked() {
        Popup.showPrompt("Discard Magazine","","Show Mag Details",() => {},(magBC) => {
            if(magBC && magBC!=="") {
                history.push(`/mag_details/${magBC}`);
                //confirmAndRemoveDiscardMag(magBC);
            }
        },1, "magazine barcode (##.####.#)");
    }
    
    function handleMoveMagClicked() {
        if(LIUtils.UserHasLevel(cookies,"ADMIN")) {
            history.push("/admin/mag_move");
            return;
        }
        Popup.show("","<p>You do not have the permissions to move magazines.</p>" +
            "Talk to your Archiver Administrator and have them add the <b>STORAGE ADMIN</b> role<br/> if you wish to change this.");
    }
    
    function handleMoveBoxClicked() {
        if(LIUtils.UserHasLevel(cookies,"ADMIN")) {
            history.push("/admin/box_move");
            return;
        }
        Popup.show("","<p>You do not have the permissions to move boxes.</p>" +
            "Talk to your Archiver Administrator and have them add the <b>STORAGE ADMIN</b> role<br/> if you wish to change this.");
    }
    
    function handleClearEventsClicked() {
        Popup.showConfirm("Clear Events?",
            "<p>Are you sure you want to remove all events from the system?</p>", "Yes, remove them!",
            null, () => {
                setIsClearingEvents(true);
                ArchiverClientApi.requestClearEvents()
                .then((numRemoved) => {
                    Popup.showInfo(`Successfully cleared ${numRemoved} events.`);
                    doUpdateInterestingCounts();
                })
                .catch(responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
                .finally(() => {
                    setIsClearingEvents(false);
                });
            });
    }
    function handleClearNotificationsClicked() {
        Popup.showConfirm("Clear Notifications?",
            "<p>Are you sure you want to remove all notifications from the system?</p><p>This removes notifications for <b>ALL USERS</b>.</p>", "Yes, remove them!",
            null, () => {
                setIsClearingNotifs(true);
                ArchiverClientApi.requestClearNotifs()
                .then((numRemoved) => {
                    Popup.showInfo(`Successfully cleared ${numRemoved} notifications.`);
                    doUpdateInterestingCounts();
                })
                .catch(responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
                .finally(() => {
                    setIsClearingNotifs(false);
                });
            });
    }
    function handleClearPrintJobsClicked() {
        Popup.showConfirm("Clear Print Jobs?",
            "<p>Are you sure you want to remove all print jobs from the system?</p>", "Yes, remove them!",
            null, () => {
                setIsClearingPrintJobs(true);
                ArchiverClientApi.requestClearPrintJobs()
                .then((numRemoved) => {
                    Popup.showInfo(`Successfully cleared ${numRemoved} print jobs.`);
                    doUpdateInterestingCounts();
                })
                .catch(responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
                .finally(() => {
                    setIsClearingPrintJobs(false);
                });
            });
    }
    
    function handleCreateMissingBoxesClicked() {
        if(LIUtils.UserHasLevel(cookies,"SERVICE")) {
            history.push("/admin/box_create");
            return;
        }
        Popup.show("","<p>You do not have the permissions to create boxes.</p>" +
            "Talk to your Archiver Administrator and have them add the <b>SERVICE</b> role<br/> if you wish to change this.");   
    }
    
    function handleClearTriageSamplesClicked() {
        return;  // do nothing
    }
    
    function hideAllTabPages() {
        hideTabPage(generalRef);
        hideTabPage(serviceRef);
        hideTabPage(magRef);
        hideTabPage(boxRef);
        hideTabPage(userRef);
        hideTabPage(locationRef);
        hideTabPage(reportRef);
        hideTabPage(deviceRef);
    }
    function hideTabPage(pageRef) {
        if(pageRef && pageRef.current) {
            pageRef.current.classList.remove("show");
            pageRef.current.classList.remove("active");
            pageRef.current.classList.add("hide");
            pageRef.current.style.display = "none";
        }
    }
    function showTabPage(pageRef) {

        // remove active page info
        hideTabPage(activePageRef);
        
        if(pageRef && pageRef.current) {
            setActivePageRef(pageRef)
            // show the page we want
            pageRef.current.classList.remove("hide");
            pageRef.current.classList.add("show");
            pageRef.current.classList.add("active");
            pageRef.current.style.display="block";
            const tabId = pageRef.current.id;
            history.replace(`/adminPage#${tabId}`);
        }
    }

    //#region GETFILES

    function showGetFileParentList() {
        return DOWNLOADABLE_FILE_PARENT_LIST.map((p, index) => {
            return <option key={index} value={p}>{p}</option>
        });
    }

    function showDownloadableFilesList() {
        if(downloadableFilesList) {
            return downloadableFilesList.map((p, index) => {
                return <option key={index} value={p}>{p}</option>
            });
        }
        return null;
    }

    function handleGetFileParentSelect(e) {
        const parentDir = e.target.value;
        document.getElementById("getFilesSelect").value=DEFAULT_PICK_FILE_VERBIAGE;
        setSelectedDownloadFile(null);
        if(!parentDir || parentDir === DEFAULT_PICK_DIR_VERBIAGE) {
            return;
        }
        setSelectedFileParentDir(parentDir);


        ArchiverClientApi.getFiles(parentDir)
        .then( ({files}) => {
            if(!files || files.length===0) {
                ErrorPopup.showError("Error","No files found");
                setDownloadableFilesList([]);
                return;
            }
            files.sort();
            files.unshift(DEFAULT_PICK_FILE_VERBIAGE);         // prepend our default selector
            setDownloadableFilesList(files); // []
        })
        .catch( responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError));
    }

    function handleGetFileSelect(e) {
        const fileToGet = e.target.value;
        if(!fileToGet || fileToGet === DEFAULT_PICK_FILE_VERBIAGE) {
            setSelectedDownloadFile(null);
            return;
        }
        setSelectedDownloadFile(fileToGet);
    }

    function handleDownloadFile() {

        setIsBusyDownloadingFile(true);
        ArchiverClientApi.downloadFileFromParentDir(selectedFileParentDir, selectedDownloadFile)
        .catch( responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
        .finally( () => setIsBusyDownloadingFile(false));
    }

    function fileIsNotSelected() {
        // noinspection RedundantIfStatementJS
        if(!selectedDownloadFile || selectedDownloadFile==="" || selectedDownloadFile===DEFAULT_PICK_FILE_VERBIAGE) { 
            return true;  // file is NOT selected
        }
        return false;  // file is selected
    }

    //#endregion GETFILES

    function dumpDownloadFilesSection() {
        return (
            <>
            <td className="w-50">
                <p>Download files from specific directories on the Archiver.</p>
                <p>*Note that files <strong>bigger than 1Meg</strong> will be compressed before sending ... this can take a while!</p>
            </td>
            <td colSpan="1">
                <div className="input-group w-100">
                    <select id="moveSelect" className="form-control" onSelect={handleGetFileParentSelect}
                            onChange={handleGetFileParentSelect}>{showGetFileParentList()}</select>
                </div>
                <div className="input-group w-100">
                    <select id="getFilesSelect" className="form-control my-3" onSelect={handleGetFileSelect}
                            onChange={handleGetFileSelect}>{showDownloadableFilesList()}</select>
                    <LIButton bgClass="ml-3" label="Download" small primary onClick={handleDownloadFile} showBusy={isBusyDownloadingFile} disabled={isBusyDownloadingFile || fileIsNotSelected()}/>
                </div>
            </td>
                </>
        );
    }
    
    function dumpResetDatabaseSection() {
        if(globalState.archiverServerInfo?.demoMode!==true) {
            return null;
        }
        
        return(
            <>
                <h4 className="li-bg-light p-3">Reset Archiver Database</h4>
                <table id="resetArchiverTable" className="table">
                    <tbody>
                    <tr>
                        <td className="w-100 text-left li-font-medium font-weight-normal">
                            <p>Reset the Archiver Database, removing all magazines, samples, retrieval orders, box transfer orders, ROs and their histories.
                            All existing contacts, locations, departments, and profiles will remain untouched.</p>
                            <p className="li-fg-danger font-weight-bold text-center">*** NOTE: this CANNOT BE UNDONE ***</p>
                        </td>
                        <td>
                            <div className="d-flex align-items-center">
                                <div style={{width:"180px"}}>
                                <label className="ml-3 mb-0 d-flex align-items-center">
                                    <input type="checkbox" checked={addSamples} 
                                           onChange={(e) => setAddSamples(e.target.checked)} className="mr-2"/>
                                    Add Demo Samples
                                </label>
                                </div>

                                <LIButton secondary fitHeight onClick={handleResetArchiverDatabase} label="Reset Database" showBusy={isBusyResettingDb}/>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </>
        );
    }
    
    function handleResetArchiverDatabase() {
        Popup.showConfirm("Reset Archiver Database", "Do you really want to clear all samples and magazines from the Archiver database?",
            "Yes, Clear it!", () => {
            }, () => {
                setIsBusyResettingDb(true);
                ArchiverClientApi.sendWipeDbRequest(addSamples)
                .then(() => {
                    Popup.showInfo("Database has been reset");
                })
                .catch(responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
                .finally(() => {
                    setIsBusyResettingDb(false);
                })
            });
    }

    function showClearEventsLabel():string {
        if(isClearingEvents) {
            return(
                <div>Clear Events &nbsp;<span className="fa fa-spinner fa-pulse fa-fw" role="status" aria-hidden="true"></span></div>
            );
        }
        return(
            `Clear Events (${dashboardCounts["eventsCount"]})`
        );
    }

    function showClearNotifsLabel():string {
        if(isClearingNotifs) {
            return(
                <div>Clear Notifications &nbsp;<span className="fa fa-spinner fa-pulse fa-fw" role="status" aria-hidden="true"></span></div>
            );
        }
        return(
            `Clear Notifications (${dashboardCounts["notifsCount"]})`
        );
    }

    function showClearPrintJobsLabel():string {
        if(isClearingPrintJobs) {
            return(
                <div>Clear Print Jobs &nbsp;<span className="fa fa-spinner fa-pulse fa-fw" role="status" aria-hidden="true"></span></div>
            );
        }
        return(
            `Clear Print Jobs (${dashboardCounts["printJobsCount"]})`
        );
    }
    
    function showExternalProcJobsLabel():string {
        return(
            `External Processing Jobs (${dashboardCounts["externalProcJobsCount"]})`
        );
    }
    
    function showNumTriageSamplesLabel():string {
        const {newCount, processingCount} = dashboardCounts["triageSamplesCount"]
        return(
            <div>Triage Samples <br/>
                <span className="li-font-small">New: {newCount}, Processing: {processingCount}</span>
            </div>
        );
    }
    
    //#region IMPORT_REPORT
    function handleImportReport() {
        showFilePicker(false);
    }

    function showFilePicker(allowMultiple, fileTypes="*") {
        const fileElement = document.getElementById("fileElem");
        fileElement.value="";                                   // clear out old file selection
        fileElement.click();
    }
    
    async function handleFileSelect(e) {
        if (!e.target.files || e.target.files.length === 0) return;
        let fileList = e.target.files; // FileList OBJECT! (not an array)

        let reportList="";
        for (let i=0;i<fileList.length;i++) {
            const fileInfo = fileList.item(i);
            reportList+=`<li>${fileInfo.name}</li>`;
        }
        
        if(fileList.length>0) {
            const msg = `<p>You are importing the following reports:</p><ul>${reportList}</ul>.  
                        Do you want to overwrite any existing reports with the same name?`;
            Popup.showConfirm("Overwrite Existing Reports?", msg, "Yes, Overwrite", ()=> {return null},
                () => uploadFiles(fileList, true),"No, Skip",() => uploadFiles(fileList, false));
        }
    }
    
    async function uploadFiles(fileList, overwriteExisting) {
        setReportUploadIsBusy(true);
        
        let failedMsg="";
        let goodMsg="";
        let failedCount=0;
        for (let i=0;i<fileList.length;i++) {
            const fileInfo = fileList.item(i);
            const fileName = fileInfo.name;
            
            const resultObj = await readSingleFileAndSend(fileInfo, overwriteExisting);
            if(resultObj.errorResult) {
                //console.error(resultObj.errorResultMsg);
                failedCount++;
                failedMsg += resultObj.errorResultMsg;
            }
            if(resultObj.goodResult) {
                goodMsg += `Import succeeded for '${fileName}'<br/>`;
            }
        }
        let popupMsg = "";
        if(goodMsg!=="") {
            popupMsg+=`<p>${goodMsg}</p>`;
        }
        if(failedMsg!=="") {
            popupMsg += `<p class="li-fg-danger font-weight-bold">Import failed (${failedCount}):</p><p>${failedMsg}</p>`;
        }

        setReportUploadIsBusy(false);
        
        Popup.show("Import Results", popupMsg===""?"no reports imported":popupMsg, () => {});
    }
    
    const readSingleFileAndSend = async (fileInfo, overwriteExisting) => {

        const delay = (delayInms) => {
            return new Promise(resolve => setTimeout(resolve, delayInms));
        };
        
        let doneSendingGood=false;
        let doneSendingError=false;
        let doneSendingErrorMsg="";
        
        const fileName=fileInfo.name;
        const reader = new FileReader();
        reader.addEventListener("load", // done reading
            () => {
                let jsonObject;
                try {
                    jsonObject = JSON.parse(reader.result);
                } catch (e) {
                    doneSendingError=true;
                    doneSendingErrorMsg=`<p>Failed to read report file '${fileName}'<br/>=> <b>${e}</b></p>`;
                    return;
                }
                
                // make sure the ID is missing! (otherwise it'll edit the one that's there now with the same ID
                jsonObject.id = null;
                ArchiverClientApi.sendReportUpdate(jsonObject, overwriteExisting, (value) => {
                    console.debug("import progress " + value);
                })
                .then(() => {
                    doneSendingGood=true;
                })
                .catch((error) => {
                    doneSendingError=true;
                    doneSendingErrorMsg=`<b>${fileName}</b> => ${error.error}<br/>`;
                });
            }, false);

        reader.addEventListener("error", () => {
            doneSendingError=true;
            doneSendingErrorMsg=`<b>${fileName}</b> => failed to read file<br/>`;
        }, false);
        reader.readAsText(fileInfo);

        while(!doneSendingGood && !doneSendingError) {
            console.debug(`waiting for import result for '${fileName}'`);
            await delay(100);
        }
        
        return {goodResult: doneSendingGood, errorResult: doneSendingError, errorResultMsg: doneSendingErrorMsg};
    }
    
    //#endregion IMPORT_REPORT
    
    return(
        <div className="container">
            <Header hideAdmin/>
            <div className="li-header-row row justify-content-between">
                <div>
                    <BackButton/>
                    <h1 className="ml-4 d-inline-block align-middle">Archiver Administration</h1>
                </div>
                <div className="align-self-center">
                    <ReloadButton/>
                </div>
            </div>

            {/* TABS */}
            <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item mr-2" role="presentation">
                    <button className={"nav-link " + (activePageRef===generalRef?"active":"")} id="general-tab" onClick={() => showTabPage(generalRef)}>General</button>
                </li>
                <li className="nav-item mr-2" role="presentation">
                    <button className={"nav-link " + (activePageRef===magRef?"active":"")} id="magazines-tab" onClick={() => showTabPage(magRef)}>Magazines</button>
                </li>
                <li className="nav-item mr-2" role="presentation">
                    <button className={"nav-link " + (activePageRef===boxRef?"active":"")} id="boxes-tab" onClick={() => showTabPage(boxRef)}>Boxes</button>
                </li>

                <li className="nav-item mr-2" role="presentation">
                    <button className={"nav-link " + (activePageRef===userRef?"active":"")} id="users-tab" onClick={() => showTabPage(userRef)}>Users</button>
                </li>
                <li className="nav-item mr-2" role="presentation">
                    <button className={"nav-link " + (activePageRef===deviceRef?"active":"")} id="devices-tab" onClick={() => showTabPage(deviceRef)}>Devices</button>
                </li>
                <li className="nav-item mr-2" role="presentation">
                    <button className={"nav-link " + (activePageRef===locationRef?"active":"")} id="locations-tab" onClick={() => showTabPage(locationRef)}>Locations/Departments</button>
                </li>
                <li className="nav-item mr-2" role="presentation">
                    <button className={"nav-link " + (activePageRef===reportRef?"active":"")} id="reports-tab" onClick={() => showTabPage(reportRef)}>Reports</button>
                </li>
                <li className="nav-item mr-2" role="presentation">
                    <button className={"nav-link " + (activePageRef===serviceRef?"active":"")} id="service-tab" onClick={() => showTabPage(serviceRef)}>Service</button>
                </li>
              
            </ul>

            {/* TAB CONTENT */}
            <div id="general" className="tab-pane fade" ref={generalRef}>
                <h4 className="p-3">General</h4>
                <table id="generalTable" className="table">
                    <tbody>
                    <tr>
                        <td className="w-75 text-left li-font-medium font-weight-normal">
                            <p>Clear out all events from the system.  Over time, there can be many events added
                                as devices report their various statuses and diagnostic issues.  It is important to
                                review these events regularly and clear them out afterwards.
                            </p>
                            <p className="li-font-small ml-3 m-0">*events are wiped completely from the system.  This cannot be undone.
                            </p>
                        </td>
                        <td className="text-right"><LIButton primary onClick={handleClearEventsClicked} fitHeight label={showClearEventsLabel()}/></td>
                    </tr>
                    <tr>
                        <td className="w-75 text-left li-font-medium font-weight-normal">
                            <p>Clear out all notifications from the system.  Notifications are sent to users via email and via the GUI.  These are ordinarily
                                removed from the system after they are around 10 days old (even if they are unread).  If the Archiver Scooter hasn't run in a while or there is
                                an excessive number of notifications being generated, you may want to remove these manually.  Do that here.
                            </p>
                            <p className="li-font-small ml-3 m-0">*notifications are wiped completely from the system.  This cannot be undone.
                            </p>
                        </td>
                        <td className="text-right"><LIButton primary onClick={handleClearNotificationsClicked} fitHeight label={showClearNotifsLabel()}/></td>
                    </tr>
                    <tr>
                        <td className="w-75 text-left li-font-medium font-weight-normal">
                            <p>Clear out all label print jobs from the system.  If a label printer has been off or there have been issues printing
                                magazine labels, there can be a long line of labels waiting to be printed.   It is sometimes useful to be able to
                                clear the internal print queue.  
                            </p>
                            <p className="li-font-small ml-3 m-0">*any previously labels that were to be printed can then be printed individually using
                                the "Reprint Label" button on 
                                the <span className="li-pointer btn-link" onClick={() => history.push("/print")}>Print Labels</span> page.
                            </p>
                        </td>
                        <td className="text-right"><LIButton primary onClick={handleClearPrintJobsClicked} fitHeight label={showClearPrintJobsLabel()}/></td>
                    </tr>
                    <tr>
                        <td className="w-75 text-left li-font-medium font-weight-normal">
                            <p>The number of external processing jobs currently in the queue.  If this number is high, the external processing
                                queue is likely full.  This can happen if the Archiver Scooter or BTO Processor are not running in a timely manner (tuning
                                may be required).
                            </p>
                        </td>
                        <td className="text-right"><LIButton primary fitHeight label={showExternalProcJobsLabel()}/></td>
                    </tr>
                    <tr>
                        <td className="w-75 text-left li-font-medium font-weight-normal">
                            <p>The number of Samples waiting for AI Triage processing (if this has been enabled).  
                                If this number is high, the there is likely something wrong with the AISampleDoctor processor (tuning
                                may be required).
                            </p>
                        </td>
                        <td className="text-right"><LIButton primary onClick={handleClearTriageSamplesClicked} 
                                                             widthPels={250}
                                                             fitHeight label={showNumTriageSamplesLabel()}/></td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div id="magazines" className="tab-pane fade" ref={magRef}>
                <h4 className="p-3">Magazines</h4>
                <table id="magTable" className="table">
                    <tbody>
                        <tr>
                            <td className="w-75 text-left li-font-medium font-weight-normal">
                                <p>Add a new magazine to the system, register a mag to a particular device, or unregister a mag from its current device.</p>
                            </td>
                            <td className="text-right"><LIButton primary onClick={()=>history.push("/admin/mag_register")} label="Register/Unregister Magazine" fitHeight/></td>
                        </tr>
                        <tr>
                            <td className="w-75 text-left li-font-medium font-weight-normal">
                                <p>Clear out a magazine, removing all of it's samples.  This is roughly the same as 'reloading' a mag at a device, where all samples are removed from the mag.</p>
                                <p>All samples will remain in the system, but will no longer be associated with this magazine, and will also be removed from Needs Attention lists.</p>
                                
                                <h4 className="li-fg-danger font-weight-bold">WARNING</h4>
                                <ul className="li-font-small">
                                    <li><span className="li-fg-danger font-weight-bold">This is dangerous</span> and will result in samples no longer being associated with this magazine.</li>
                                    <li>Be sure you have the samples in a <span className="li-fg-danger font-weight-bold">known location</span> before proceeding.</li>
                                    <li>Samples will remain in the system, <i className="li-fg-danger">but will no longer be in a mag and will no longer be easy to find!</i></li>
                                    <li>The mag may need to be re-assigned to a device before being loadable.</li>
                                </ul>
                            </td>
                            <td className="text-right"><LIButton primary onClick={handleClearMagClicked} label="Clear Magazine" fitHeight/></td>
                        </tr>
                        <tr>
                            <td className="w-75 text-left li-font-medium font-weight-normal">
                                <p>Discard a magazine's samples, clearing the magazine of all samples and resetting its discard date.</p>
                            </td>
                            <td className="text-right"><LIButton primary onClick={handleDiscardMagClicked} label="Discard Magazine" fitHeight/></td>
                        </tr>
                        <tr>
                            <td className="w-75 text-left li-font-medium font-weight-normal">
                                <p>Move a magazine to a new physical location.</p>
                                <p className="li-font-small">
                                <b>*Note:</b> before you use this feature, consider performing a <b>BOX Transfer</b> instead, since that will move
                                the entire box of mags, keeping them together.    This <i>move single magazine</i> feature is for when you need to move a single mag due to some
                                other, non-typical reason.
                                </p>
                            </td>
                            <td className="text-right"><LIButton primary onClick={handleMoveMagClicked} label="Move Magazine" fitHeight/></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div id="boxes" className="tab-pane fade" ref={boxRef}>
                <h4 className="p-3">Boxes</h4>
                <table id="magTable" className="table">
                    <tbody>
                        <tr>
                            <td className="w-75 text-left li-font-medium font-weight-normal">
                                <p>Move a box to a new physical location.</p>
                                <p className="li-font-small">
                                    <b>*Note:</b> before you use this feature, consider performing a <b>BOX Transfer</b> instead, since that will move
                                    the entire box of mags, keeping them together as well as enabling a cancel feature.    This <i>move single box</i> feature is for when you need to move a single box due to some
                                    other, non-typical reason.
                                </p>
                            </td>
                            <td className="text-right"><LIButton primary onClick={handleMoveBoxClicked} label="Move Box" fitHeight/></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div id="users" className="tab-pane fade" ref={userRef}>
                <h4 className="p-3">Users</h4>
                <table id="userTable" className="table">
                    <tbody>
                    <tr>
                        <td className="w-100 text-left li-font-medium font-weight-normal">
                            <p>Add, Edit, and Delete SlideSystem users.</p>
                        </td>
                        <td><LIButton primary onClick={()=>history.push("/admin/users")} bgClass="fa fa-edit"/></td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div id="devices" className="tab-pane fade" ref={deviceRef}>
                <h4 className="p-3">Devices</h4>
                <table id="deviceTable" className="table">
                    <tbody>
                        <tr>
                            <td className="w-100 text-left li-font-medium font-weight-normal">
                                <p>Add and remove sample processing devices from the system, as well as assign
                                    magazine and sample profiles and Profile Sets to these devices.</p>
                                <p className="li-font-small ml-3 m-0">
                                    *NOTE: ADMIN level users can update device profiles, but Service level is required to add/remove or edit device details.
                                </p>
                            </td>
                            <td><LIButton primary onClick={() => history.push("/admin/devices")} bgClass="fa fa-edit"/></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div id="locations" className="tab-pane fade" ref={locationRef}>
                <h4 className="p-3">Locations and Departments</h4>
                <table id="locationTable" className="table">
                    <tbody>
                    <tr>
                        <td className="w-100 text-left li-font-medium font-weight-normal">
                            <p>Add, Edit, and Delete Locations and Departments.</p>
                        </td>
                        <td><LIButton primary onClick={()=>history.push("/admin/locations")} bgClass="fa fa-edit"/></td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div id="reports" className="tab-pane fade" ref={reportRef}>
                <h4 className="p-3">Reports</h4>
                <table id="reportsTable" className="table">
                    <tbody>
                    <tr>
                        <td className="w-75 text-left li-font-medium font-weight-normal">
                            <p>Add, edit, delete, and export system reports.</p>
                            <p className="li-font-small">NOTE: this is considered an Advanced Topic and requires an understanding
                                of SQL and the Archiver database structure.</p>
                        </td>
                        <td className="text-right"><LIButton primary onClick={()=>history.push("/admin/reports")} label="Edit" fitHeight faIcon="ml-2 fa fa-edit"/></td>
                    </tr>
                    <tr>
                        <td className="w-75 text-left li-font-medium font-weight-normal">
                            <p>Import one or more reports into the system</p>
                        </td>
                        <td className="text-right"><LIButton primary onClick={handleImportReport} fitHeight label="Import" faIcon="ml-2 fa fa-upload" showBusy={reportUploadIsBusy}/></td>
                    </tr>
                    </tbody>
                </table>
                <input type="file" id="fileElem" accept=".json" style={{display: "none"}} 
                       multiple onSelect={async(e) =>handleFileSelect(e)} 
                       onChange={async(e) =>handleFileSelect(e)}/>
            </div>
            <div id="service" className="tab-pane fade" ref={serviceRef}>

                <HeaderBadge title=" service level only " danger icon="fa-exclamation-circle" medium/>

                <div className="mb-4">
                    <h5 className="li-bg-dark p-3">General Archiver Info</h5>
                    <table id="archiverInfoTable" className="table table-sm table-bordered">
                        <tbody>
                            <tr>
                                <td className="text-right font-weight-bold">Name</td>
                                <td>{globalState.archiverServerInfo.name}</td>
                            </tr>
                            <tr>
                                <td className="text-right font-weight-bold">WebService Version</td>
                                <td>{globalState.archiverServerInfo.version}</td>
                            </tr>
                            <tr>
                                <td className=" text-right font-weight-bold">Database Version</td>
                                <td>{globalState.archiverServerInfo.dbVersion}</td>
                            </tr>
                            <tr>
                                <td className=" text-right font-weight-bold">Min Required DB Version</td>
                                <td>{globalState.archiverServerInfo.requiredDbVersion}</td>
                            </tr>
                            <tr>
                                <td className=" text-right font-weight-bold">Demo Mode?</td>
                                <td>{globalState.archiverServerInfo.demoMode?"On":"Off"}</td>
                            </tr>
                            <tr>
                                <td className=" text-right font-weight-bold">Server Time (UTC)</td>
                                <td>{globalState.archiverServerInfo.localTimeUtc}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                

                {/* SERVICE LEVEL SELECTIONS */}
                {LIUtils.UserHasLevel(cookies, "SERVICE") &&
                    <div className="mb-4">
                        <h4 className="li-bg-light p-3">Profiles</h4>
                        <table id="profilesTable" className="table">
                            <tbody>
                                <tr>
                                    <td className="w-75 text-left li-font-medium font-weight-normal">
                                        <p>Add, Edit, and Delete Profile Sets.</p>
                                    </td>
                                    <td className="text-right"><LIButton primary
                                                                         onClick={() => history.push("/admin/profile_sets")}
                                                                         label="Profile Sets"
                                                                         fitHeight faIcon="ml-2 fa fa-edit"/></td>
                                </tr>
                                <tr>
                                    <td className="w-75 text-left li-font-medium font-weight-normal">
                                        <p>Add, Edit, and Delete Mag and Sample profiles.</p>
                                        <p className="li-font-small">NOTE: this is considered an Advanced Topic and
                                            requires an understanding
                                            of how barcodes are read and processed by the Slide System.</p>
                                    </td>
                                    <td className="text-right"><LIButton primary
                                                                         onClick={() => history.push("/admin/profiles")}
                                                                         label="Profiles"
                                                                         fitHeight faIcon="ml-2 fa fa-edit"/></td>
                                </tr>

                            </tbody>
                        </table>
                        <h4 className="li-bg-light p-3">Container Types</h4>
                        <table id="magTypesTable" className="table">
                            <tbody>
                                <tr>
                                    <td className="w-75 text-left li-font-medium font-weight-normal">
                                        <p>Add, Edit, and Delete Magazine Types.</p>
                                        <p className="li-font-small">NOTE: this is considered an Advanced Topic and requires an understanding
                                            of how magazine types are used in the Slide System.</p>
                                    </td>
                                    <td className="text-right"><LIButton primary onClick={() => history.push("/admin/mag_types")} label="Mag Types" fitHeight faIcon="ml-2 fa fa-edit" /></td>
                                </tr>
                                <tr>
                                    <td className="w-75 text-left li-font-medium font-weight-normal">
                                        <p>Add, Edit, and Delete Sample Types.</p>
                                        <p className="li-font-small">NOTE: this is considered an Advanced Topic and requires an understanding
                                            of how magazine types are used in the Slide System.</p>
                                    </td>
                                    <td className="text-right"><LIButton primary onClick={() => history.push("/admin/sample_types")} label="Sample Types" fitHeight faIcon="ml-2 fa fa-edit"/></td>
                                </tr>
                            </tbody>
                        </table>
                        <h4 className="li-bg-light p-3">Boxes</h4>
                        <table id="boxesTable" className="table">
                            <tbody>
                                <tr>
                                    <td className="w-75 text-left li-font-medium font-weight-normal">
                                        <p>Create Missing Boxes</p>
                                        <p className="li-font-small">In older systems, boxes did not exist as standalone entities  This service level function forces the system
                                            to go through the mags list and creates boxes for each set of mags that may not have a matching box in the system.
                                            Box histories and locations will be created as well based on the original magazine data.</p>
                                    </td>
                                    <td className="text-right">
                                        <LIButton primary onClick={handleCreateMissingBoxesClicked} label="Create Missing Boxes" fitHeight/></td>
                                </tr>
                            </tbody>
                        </table>
                        <h4 className="li-bg-light p-3">File Download</h4>
                        <table id="fileDownloadTable" className="table">
                            <tbody>
                            <tr>{dumpDownloadFilesSection()}</tr>
                            </tbody>
                        </table>
                        {dumpResetDatabaseSection()}
                    </div>
                }
            </div>

            {/* FOOTER CONTENT */}
            <div className="m-5">&nbsp;</div>
        </div>
    );
}

export default AdminPage;